module.exports = __webpack_public_path__ + "static/img/environment.d28f5c60.png";